<label class="ez-input"
       [ngClass]="{'is-focus': isFocus$ | async, 'is-active': isActive$ | async, 'is-read-only': isReadOnly,
       'is-error': isInvalidStatus$ | async, 'is-required': isRequired}"
>
  <div class="ez-input__right" *ngIf="content && content.templateRef">
    <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
  </div>

  <span class="ez-input__field">
    <div class="ez-input__label">
      <ng-content select="[ezLabel]"></ng-content>
    </div>
    <ng-content></ng-content>
  </span>

  <span class="ez-input__message small">
    <ng-content select="[ezHint]"></ng-content>
  </span>

  <span class="ez-input__message small is-error">
    <ng-content select="[ezError]"></ng-content>
  </span>
</label>
